<template>
  <label class="gc-shared-opentowork_switch">
    <input
      @click="toggleOpenToWork"
      type="checkbox"
      :checked="opentoworkStatus"
    />
    <span class="gc-shared-opentowork_slider"></span>
  </label>
</template>

<script>
export default {
  name: "gcOpentoworkSwitch",
  computed: {
    opentoworkStatus() {
      return Grabcad.opentoworkStore.state.opentoworkStatus;
    },
  },
  methods: {
    toggleOpenToWork() {
      Grabcad.opentoworkStore.dispatch("toggleOpentoworkStatus");
    },
  },
};
</script>
